import { render, staticRenderFns } from "./week-summary.vue?vue&type=template&id=487dd097&scoped=true&"
import script from "./week-summary.vue?vue&type=script&lang=js&"
export * from "./week-summary.vue?vue&type=script&lang=js&"
import style0 from "./week-summary.vue?vue&type=style&index=0&id=487dd097&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "487dd097",
  null
  
)

export default component.exports